import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

interface SortByTypes {
  sortBy: string;
}

type PayLoadType = string;

const initialState: SortByTypes = {
  sortBy: 'byDistance:ASC',
};

const sortBySlice = createSlice({
  name: 'sortBy',
  initialState,
  reducers: {
    setInitialSortBy: (_state: SortByTypes, action: PayloadAction<PayLoadType>) => {
      return { sortBy: action.payload };
    },
    setSortBy: (_state: SortByTypes, action: PayloadAction<PayLoadType>) => {
      localStorage.setItem('sortBy', JSON.stringify(action.payload));
      return { sortBy: action.payload };
    },
  },
});

export const selectSortBy = (state: RootState) => state.sortBy;

export const { setInitialSortBy, setSortBy } = sortBySlice.actions;

export default sortBySlice.reducer;
